module.exports = __webpack_public_path__ + "img/emp-intro-request-access.0bc89476.png";